
import React from 'react';
import type { GA4ReportData } from '../types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface ReportChartProps {
  data: GA4ReportData[];
}

const ReportChart: React.FC<ReportChartProps> = ({ data }) => {
  return (
    <div className="bg-base-200 p-4 rounded-lg my-2 h-80 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{
            top: 5,
            right: 20,
            left: -10,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#4B5563" />
          <XAxis dataKey="date" stroke="#D1D5DB" />
          <YAxis stroke="#D1D5DB" />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#374151',
              border: '1px solid #4B5563',
              borderRadius: '0.5rem'
            }} 
            labelStyle={{ color: '#F9FAFB' }}
          />
          <Legend wrapperStyle={{ color: '#D1D5DB' }} />
          <Bar dataKey="sessions" fill="#6366F1" />
          <Bar dataKey="conversions" fill="#8B5CF6" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReportChart;
